import {
  GET_PRODUCT_UNIT_BY_PRODUCT_ID_RESPONSE,
  GET_PRODUCT_UNIT_TYPE_RESPONSE,
  ADD_PRODUCT_UNIT_RESPONSE,
  UPDATE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_RESPONSE,
  UPDATE_PRODUCT_UNIT_STATUS_BY_PRODUCT_UNIT_ID_RESPONSE,
  DELETE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_RESPONSE,
} from "./actionTypes";

import produce from "immer";

export const initialState = {
  productUnitApiResponse: null,
  productUnitTypeList: [],
  productUnitData: [],
  productUnitRecord: null,
};

const productUnit = (state = initialState, action) =>
  produce(state, (draft) => {
    let response;
    switch (action.type) {
      case GET_PRODUCT_UNIT_BY_PRODUCT_ID_RESPONSE:
        response = action.payload.apiResponse;
        if (response.isSuccessResponse) {
          draft.productUnitData = response.responseData;
        } else {
          draft.productUnitData = [];
        }
        break;

      case GET_PRODUCT_UNIT_TYPE_RESPONSE:
        response = action.payload.apiResponse;
        if (response.isSuccessResponse) {
          draft.productUnitTypeList = response.responseData;
        } else {
          draft.productUnitTypeList = [];
        }
        break;

      case ADD_PRODUCT_UNIT_RESPONSE:
        draft.productUnitApiResponse = action.payload.apiResponse;
        break;

      case UPDATE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_RESPONSE:
        draft.productUnitApiResponse = action.payload.apiResponse;
        break;

      case UPDATE_PRODUCT_UNIT_STATUS_BY_PRODUCT_UNIT_ID_RESPONSE:
        draft.productUnitApiResponse = action.payload.apiResponse;
        break;

      case DELETE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_RESPONSE:
        draft.productUnitApiResponse = action.payload.apiResponse;
        break;

      default:
        state = { ...state };
        break;
    }
  });

export default productUnit;
